

import { NgModule } from '@angular/core';
import { SelectAbstractComponent } from './select-abstract.component';

@NgModule({
  declarations: [SelectAbstractComponent],
  imports: [],
})
export class SelectAbstractModule { }
